export default {
    ca: {
        title: 'Galeria de mapes',
    },
    es: {
        title: 'Galería de mapas',
    },
    en: {
        title: 'Map gallery',
    },
};



// WEBPACK FOOTER //
// ./src/gallery/gallery-translations.js